export function createPromiseActionTypes(actionName) {
  return {
    TYPE: actionName,
    PENDING: `${actionName}_PENDING`,
    FULFILLED: `${actionName}_FULFILLED`,
    REJECTED: `${actionName}_REJECTED`
  };
}

export const handleEntities = (state, payload, schema) => ({
  ...state,
  entities: getEntities(state, payload, schema),
  result: payload.result
});

export const getEntities = (state, payload, schema) => ({
  ...state.entities,
  ...payload.entities[schema]
});
